import React from "react";
import { FaBan, FaClock, FaExclamationTriangle, FaRegFileAlt, FaWifi } from "react-icons/fa";
import Pages from "../../pages/LanguagePage";
import { DOCUMENT_STATUS, roleDocumentsText } from "../../../utils/roleDocuments";
import "./roleDocuments.css";

// One document (Business Plan / Terms / Final Agreement) of the viewed role,
// with a distinct message per state -- "no permission" is never shown as
// "no data", and an expired invitation says so.
const RoleDocumentContent = ({ infoSource, status, document, errorCode, onRetry, className = "" }) => {
  const t = (key, fallback) => roleDocumentsText(infoSource, key, fallback);

  if (status === DOCUMENT_STATUS.SUCCESS) {
    return (
      <div className={`role-doc-content ${className}`}>
        <Pages classAlert="container" paragra0={document} infoSource={infoSource} />
      </div>
    );
  }

  const states = {
    [DOCUMENT_STATUS.LOADING]: { icon: null, tone: "info", text: t("loadingDocument", "Loading document...") },
    [DOCUMENT_STATUS.IDLE]: { icon: null, tone: "info", text: t("loadingInvitation", "Loading invitation information...") },
    [DOCUMENT_STATUS.EMPTY]: { icon: FaRegFileAlt, tone: "muted", text: t("empty", "This document is not available yet for this role.") },
    [DOCUMENT_STATUS.FORBIDDEN]: {
      icon: FaBan,
      tone: "warning",
      text: errorCode === "RECIPIENT_MISMATCH"
        ? t("recipientMismatch", "This invitation belongs to another account. Sign out, then open the link again.")
        : t("forbidden", "You are not authorized to view this document."),
    },
    [DOCUMENT_STATUS.EXPIRED]: { icon: FaClock, tone: "warning", text: t("expired", "This invitation has expired.") },
    [DOCUMENT_STATUS.NETWORK_ERROR]: { icon: FaWifi, tone: "danger", text: t("networkError", "Network error. Check your connection and try again."), retry: true },
    [DOCUMENT_STATUS.SERVER_ERROR]: { icon: FaExclamationTriangle, tone: "danger", text: t("loadError", "Unable to load role information."), retry: true },
  };
  const state = states[status] || states[DOCUMENT_STATUS.SERVER_ERROR];
  const Icon = state.icon;

  return (
    <div
      className={`role-doc-state role-doc-state--${state.tone} ${className}`}
      role={state.tone === "danger" ? "alert" : "status"}
      aria-live="polite"
      aria-busy={status === DOCUMENT_STATUS.LOADING || undefined}
    >
      {Icon ? <Icon className="role-doc-state-icon" aria-hidden="true" /> : <span className="role-doc-spinner" aria-hidden="true" />}
      <p className="role-doc-state-text">{state.text}</p>
      {state.retry && onRetry && (
        <button type="button" className="btn btn-outline-primary btn-sm role-doc-retry" onClick={onRetry}>
          {t("retry", "Try again")}
        </button>
      )}
    </div>
  );
};

export default RoleDocumentContent;
